<template>
    <div>
        <div
            v-if="! hasDeliveryCompanies"
            class="w-full flex justify-left items-center cursor-pointer"
            @click="openModal"
        >
            <span class="icon-circle bg-accent-clay-orange-dark">
                <font-awesome-icon icon="plus" class="text-white" />
            </span>
            <span class="text-md ml-md text-black">
                Tilldela entreprenör
            </span>
        </div>
        <div v-else>
            <button
                title="Tilldela entreprenör"
                class="btn btn-md is-primary px-xl"
                :disabled="disabled"
                @click="openModal"
            >
                Tilldela entreprenör
            </button>
        </div>
        <adaptive-form-modal
            name="delivery-project-assign-company"
            primary-button-text="Spara"
            primary-button-class="is-primary"
            title="Tilldela entreprenör"
            method="patch"
            :action="route('api.delivery-projects.companies.update', deliveryProject)"
            :redirect-to="route('admin.delivery-projects.show', deliveryProject)"
        >
            <div>
                <select-input
                    v-model="company_id"
                    name="company_id"
                    :options="companies"
                    :required="true"
                    placeholder="Välj..."
                >
                    Entreprenör
                </select-input>
                <checkbox-input
                    v-model="installation"
                    name="installation_phase"
                    class="my-md"
                    value="1"
                    :disabled="deliveryProject.installation_phase_company_id !== null"
                >
                    Installation
                </checkbox-input>
                <checkbox-input
                    v-model="dig"
                    name="dig_phase"
                    class="my-md"
                    value="1"
                    :disabled="deliveryProject.dig_phase_company_id !== null"
                >
                    Tomtgrävning
                </checkbox-input>
                <checkbox-input
                    v-model="activation"
                    name="activation_phase"
                    class="my-md"
                    value="1"
                    :disabled="deliveryProject.activation_phase_company_id !== null"
                >
                    Driftsättning
                </checkbox-input>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            hasDeliveryCompanies: {
                type: Boolean,
                required: false,
            },
            deliveryProject: {
                type: Object,
                required: true,
            },
            companies: {
                type: Object,
                required: true,
            },
            disabled: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                company_id: null,
                dig: null,
                installation: null,
                activation: null,
            };
        },
        methods: {
            openModal() {
                if (this.disabled) {
                    return;
                }

                this.$modal.show('delivery-project-assign-company');
            },
        },
    };
</script>
